const Q_VENUE = "venue"

export { Q_VENUE }
export const EXTENSION_NAME = "em-service"
